import React from 'react';

const Terms = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-medium tracking-wide mb-8">TERMS OF SERVICE</h1>
      <p className="text-sm text-gray-500 mb-8">Last updated: January 2025</p>
      
      <div className="space-y-6 text-gray-700 text-sm leading-relaxed">
        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Agreement to Terms</h2>
          <p>
            By accessing and using the Dïtris website, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using this site.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Use License</h2>
          <p>
            Permission is granted to temporarily access the materials on Dïtris's website for personal, non-commercial use only. This license shall automatically terminate if you violate any of these restrictions.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Product Information</h2>
          <p>
            We make every effort to display our products and their colors as accurately as possible. However, we cannot guarantee that your device's display will accurately reflect the actual color of the products. All products are subject to availability, and we reserve the right to discontinue any product at any time.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Pricing and Payment</h2>
          <p>
            All prices are in USD and are subject to change without notice. We reserve the right to refuse or cancel any order for any reason, including pricing errors. Payment must be received before orders are processed.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Order Acceptance</h2>
          <p>
            Your receipt of an order confirmation does not signify our acceptance of your order. We reserve the right to accept or decline your order for any reason. If we cancel your order after payment has been processed, we will issue a full refund.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Shipping and Delivery</h2>
          <p>
            We aim to ship all orders within 1-2 business days. Delivery times are estimates and not guaranteed. We are not responsible for delays caused by shipping carriers or customs.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Returns and Refunds</h2>
          <p>
            Please refer to our Shipping & Returns page for detailed information about our return policy. Returns must be initiated within 30 days of delivery.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Intellectual Property</h2>
          <p>
            All content on this website, including text, graphics, logos, images, and software, is the property of Dïtris and is protected by copyright and trademark laws. Unauthorized use of any materials may violate copyright, trademark, and other laws.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Limitation of Liability</h2>
          <p>
            Dïtris shall not be liable for any damages arising from the use or inability to use our products or website. This includes, but is not limited to, direct, indirect, incidental, punitive, and consequential damages.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">User Conduct</h2>
          <p className="mb-2">You agree not to:</p>
          <ul className="list-disc list-inside ml-4 space-y-1">
            <li>Use the site for any unlawful purpose</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Interfere with or disrupt the site or servers</li>
            <li>Submit false or misleading information</li>
            <li>Infringe on intellectual property rights</li>
          </ul>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Governing Law</h2>
          <p>
            These terms shall be governed by and construed in accordance with the laws of the State of New York, without regard to its conflict of law provisions.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Changes to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to the website. Your continued use of the site after changes are posted constitutes your acceptance of the modified terms.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Contact Information</h2>
          <p>
            Questions about these Terms of Service should be sent to:
          </p>
          <p className="mt-2">
            Email: legal@ditris.com<br />
            Phone: +1 (555) 123-4567<br />
            Address: 123 Fashion Street, New York, NY 10001
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;